import { render, staticRenderFns } from "./AppNavigationLink.vue?vue&type=template&id=a1a63cae&"
import script from "./AppNavigationLink.vue?vue&type=script&lang=js&"
export * from "./AppNavigationLink.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigationLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports